import CustomSelect from "../../../common/interactive/CustomSelect"
import WorkQGeneralWidget from "./WorkQGeneralWidget"
import { useState } from "react"
import { getItemFromStorageSimple, setStorageItem } from "../../../../lib/script"

const DASHBOARD_WORKQ_TEAM_FILTER_KEY = 'dashboardWorkqTeamFilter'

function dashboardWorkqTeamFilterStorageKey() {
    const user = getItemFromStorageSimple('user')
    return user?.id ? `${DASHBOARD_WORKQ_TEAM_FILTER_KEY}_${user.id}` : DASHBOARD_WORKQ_TEAM_FILTER_KEY
}

function resolveSelectedTeam(userWorkqs) {
    const defaultTeam = userWorkqs.workqs[0]?.value
    if (defaultTeam == null) {
        return defaultTeam
    }

    const storedTeam = getItemFromStorageSimple(dashboardWorkqTeamFilterStorageKey())
    if (storedTeam == null) {
        return defaultTeam
    }

    const isValidTeam = userWorkqs.workqs.some((item) => item.value == storedTeam)
    return isValidTeam ? storedTeam : defaultTeam
}

export default function WorkQWidgetsWrapperMultiple({userWorkqs, classes}) {
    const [selectedTeam, setSelectedTeam] = useState(() => resolveSelectedTeam(userWorkqs))
    function handleTeamChange(value) {
        const teamValue = value.data.value
        setSelectedTeam(teamValue)
        setStorageItem(dashboardWorkqTeamFilterStorageKey(), teamValue)
    }
    return <>
        <div className={classes.workq_widgets_wrapper_multiple_select}>
        <CustomSelect 
            name="team"
            label="Filter WQs by Team"
            optionsData={userWorkqs.workqs}
            identifier={{type: 'team'}}
            preSelectedValue={selectedTeam}
            action={handleTeamChange}
        />
        </div>
        {userWorkqs.workqs.find(item => item.value == selectedTeam)?.workqs && userWorkqs.workqs.find(item => item.value == selectedTeam)?.workqs.length > 0 && <>
            {/* <h3 className={classes.team_name}>{userWorkqs.workqs.find(item => item.value == selectedTeam)?.label}</h3> */}
            <div className={classes.workq_widgets_wrapper}>
                {userWorkqs.workqs.find(item => item.value == selectedTeam)?.workqs.map(workq => (
                    <WorkQGeneralWidget key={workq.slug} workq={workq} />
                ))}
            </div>
        </>}
        {/* {userWorkqs.workqs.map(item => (
            <div key={item.value}>
                {item.workqs && item.workqs.length > 0 && <>
                    <h3 className={classes.team_name}>{item.label}</h3>
                    <div className={classes.workq_widgets_wrapper}>
                        {item.workqs.map(workq => (
                            <WorkQGeneralWidget key={workq.slug} workq={workq} />
                        ))}
                    </div>
                </>}
                
            </div>
        ))} */}
    </>
}